export default {
  default: () => import("/home/zedplan/www/divas-web-ssr/layouts/default.vue").then(m => m.default || m),
  minimal: () => import("/home/zedplan/www/divas-web-ssr/layouts/minimal.vue").then(m => m.default || m)
}